import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from './features/shared/loader/loader.service';
import { LanguageService } from './services/language.service';
import { DevToolsDetectionService } from './services/dev-tools-detection.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = '1p-app';
  sidebarCollapsed = false;

  private _loader = inject(LoaderService);
  private _language = inject(LanguageService);
  private _devTools = inject(DevToolsDetectionService);

  isLoading = this._loader.loading$;
  isLoaderSuppressed = this._loader.suppressed$;
  loaderMessage = this._loader.message$;
  isDevToolsBlocked = this._devTools.blocked;

  urlIdentifier = window.location.href

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    const allowedHosts = [
      environment.oldUrl
    ];

    try {
      const currentUrl = new URL(this.urlIdentifier);

      if (allowedHosts.includes(currentUrl.hostname)) {
        currentUrl.hostname = environment.newUrl;
        window.location.replace(currentUrl.toString());
      }
    } catch (error) {
      console.error('Invalid URL:', error);
    }

    this.matIconRegistry.addSvgIcon(
      'arrow-left-broken',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/solar-arrow-left-broken.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/solar-alt-arrow-right-linear.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'check-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/solar-check-circle.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'arrow-right-linear',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/solar-arrow-right.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'add-new-linear',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarAddCircleLinear.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'check-linear',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarUnreadLinear.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'setting-custom',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarSettingsLinear.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'download-linear',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarDownloadLinear.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'ript-refresh',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/RiptRefresh.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'filter-duotone',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarFilterBoldDuotone.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'attachment',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/SolarPaperclipOutline.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'edit-note',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/edit-note.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'areaSetting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/Settings/areaSetting.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'financeSetting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/Settings/financeSetting.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'mciSetting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/Settings/MciSetting.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'projectTeamSetting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/Settings/projecteamSetting.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'coordinatorSetting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/Settings/coordinatorSetting.svg'
      )
    );
  }


  onSidebarToggled(collapsed: boolean) {
    this.sidebarCollapsed = collapsed;
  }
}
